export default __webpack_public_path__ + "static/media/resume-icon.cf18cb5e.svg";